import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
    useMediaQuery,
} from "@chakra-ui/react";
import {RequestAction} from "../../models";
import ChatWindow from "./ChatWindow";

type ChatListDrawerProps = {
    archived?: boolean
    isOpen: boolean
    onClose: VoidFunction
    note?: string
    onAction: (v: RequestAction) => void
    participants: number
    title: string
}

function ChatListDrawer(p: ChatListDrawerProps) {
    const [isLargeScreen] = useMediaQuery(`(min-width: 768px)`);
    return <Drawer
        isOpen={p.isOpen}
        size="lg"
        placement={isLargeScreen ? "right": "bottom"}
        onClose={p.onClose}
    >
        <DrawerOverlay />
        <DrawerContent h="100dvb" sx={{zIndex: "2000"}} isolation="isolate">
            <DrawerBody px="0" py="0" w="full">
                <ChatWindow
                    archived={p.archived}
                    onAction={p.onAction}
                    title={p.title}
                    participants={p.participants}
                    note={p.note}
                />
            </DrawerBody>
        </DrawerContent>
    </Drawer>;
}

export default ChatListDrawer;
